export default {
  fetchingKeywords: [],
  fetchingKeywordResults: [],
  fetchingAdditionalResults: [],
  additionalResultErrors: [],
  selectedKeyword: null,
  keywords: [],
  results:[],
  additionalResults:{},
}